import { render } from "./LocaleSelector.vue?vue&type=template&id=f81678d8"
import script from "./LocaleSelector.vue?vue&type=script&lang=js"
export * from "./LocaleSelector.vue?vue&type=script&lang=js"
script.render = render

export default script